import { postGeneral, getGeneralById, getTaskList, putGeneral, generalById, changeStatus } from 'services/generalService';
import { toast } from 'react-toastify';
import { processErrorResponse } from 'utils/errorHandler';
import logger from 'utils/logger';

export const createGeneral = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'GENERAL_POST_REQUEST' });
    try {
        const result = await postGeneral(endpoint, data);
        dispatch({ type: 'GENERAL_POST_SUCCESS', payload: result });

        toast.success("Task has been added successfully!");
    } catch (error) {
        dispatch({ type: 'GENERAL_POST_FAILURE', error: error.message });
        processErrorResponse(error);
        logger.error('Error in createGeneral action:', error);
        throw error;
    }
};

export const batchCount = (endpoint, data) => async (dispatch) => {
    // Don't dispatch loading actions to run silently
    try {
        // Pass silent flag to skip loading bar
        const result = await postGeneral(endpoint, data, {
            headers: {
                'X-Silent-Request': 'true'
            }
        });
        // Don't dispatch success action to avoid triggering global loading
        return result;
    } catch (error) {
        // Silently handle errors without showing toast
        logger.error('Batch count error:', error);
        throw error;
    }
};

export const updateGeneral = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'GENERAL_PUT_REQUEST' });
    try {
        const result = await putGeneral(endpoint, data);
        dispatch({ type: 'GENERAL_PUT_SUCCESS', payload: result });

        toast.success("Task has been updated successfully!");
    } catch (error) {
        dispatch({ type: 'GENERAL_PUT_FAILURE', error: error.message });
        processErrorResponse(error);
        throw error;
    }
};

export const getList = (params) => async (dispatch) => {

    if (!params.silent) {
      dispatch({ type: "GET_TASK_LOADING" });
    }
    try {
        // Remove silent from query params
        const { silent, ...queryParams } = params;
        const searchParams = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => searchParams.append(key, v)); 
        // produces: ?resourceType=1&resourceType=3
      } else if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, value);
      }
    });

    const query = searchParams.toString() ? `?${searchParams.toString()}` : "";

        // Add silent header if silent is true
        const options = silent ? {
            headers: {
                'X-Silent-Request': 'true'
            }
        } : {};

        const data = await getTaskList(`/workItems${query}`, "GET", null, options);
        dispatch({ type: "GET_TASK_SUCCESS", payload: data });
    } catch (error) {
        dispatch({ type: "GET_TASK_FAILURE", payload: error.message });
        processErrorResponse(error);
    }
};

export const fetchGeneralById = (id) => async (dispatch) => {
    dispatch({ type: 'GENERAL_GETBYID_REQUEST' });
    try {
        const result = await getGeneralById('/workItems', id);
        dispatch({ type: 'GENERAL_GETBYID_SUCCESS', payload: result });
    } catch (error) {
        dispatch({ type: 'GENERAL_GETBYID_FAILURE', error: error.message });
        processErrorResponse(error);
    }
};

export const editGeneralById = (id) => async (dispatch) => {
    dispatch({ type: 'GENERAL_GETBYID_REQUEST' });
    try {
        const result = await generalById('/workItems', id,"/edit");
        dispatch({ type: 'GENERAL_GETBYID_SUCCESS', payload: result });
    } catch (error) {
        dispatch({ type: 'GENERAL_GETBYID_FAILURE', error: error.message });
        processErrorResponse(error);
    }
};

export const toggleStatus = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'TOGGLE_STATUS_REQUEST' });
    try {
        const result = await putGeneral(endpoint, data);
        dispatch({ type: 'TOGGLE_STATUS_SUCCESS', payload: result });
        toast.success("Task status has been updated successfully!");
    } catch (error) {
        dispatch({ type: 'TOGGLE_STATUS_FAILURE', error: error.message });
        processErrorResponse(error);
    }
};

export const editStatus = (endpoint, data) => async (dispatch) => {
    dispatch({ type: 'CHANGE_STATUS_REQUEST' });
    try {
        const result = await changeStatus(endpoint, data);
        dispatch({ type: 'CHANGE_STATUS_SUCCESS', payload: result });
        toast.success("Task status has been updated successfully!");
    } catch (error) {
        dispatch({ type: 'CHANGE_STATUS_FAILURE', error: error.message });
        processErrorResponse(error);
    }
};